import { createContext, useContext } from 'react';
import { CampaignFamilyEnum } from 'sonata-static-storage/lib/schemas/campaign/campaign.schema';

import type { BaseCurrencyInterface } from 'sonata-static-storage/lib/schemas/baseCurrency/baseCurrency.schema';
import type { RetargetingSegmentType } from 'sonata-static-storage/lib/schemas/targeting/Audience/Audience.types';
import type { TargetingBaseType } from 'sonata-static-storage/lib/schemas/targeting/TargetingBaseType';
import type { UserInterface } from 'sonata-static-storage/lib/schemas/user/user.schema';
import type { UserRoleInterface } from 'sonata-static-storage/lib/schemas/user/userRole.schema';
import type { AudienceGroup } from '@/components/Targeting/AudienceTargeting/AudienceTargeting';

export type AppSiteSearchEntry = {
  keys: string[];
  search: string;
};

export type AppSitePublishersConfiguration = {
  blacklistedGenericPublishers?: string[];
  blacklistedPublishers?: string[];
  blacklistedStrictPublishers?: string[];
  blacklistedStrictSearches?: AppSiteSearchEntry[];
  whitelistedGenericPublishers?: string[];
  whitelistedPublishers?: string[];
  whitelistedStrictPublishers?: string[];
  whitelistedStrictSearches?: AppSiteSearchEntry[];
};

export interface TargetingContextProps {
  budget?: number;
  countries?: string[];
  currency?: BaseCurrencyInterface;
  familyType?: CampaignFamilyEnum;
  resetSection: (id: string) => void;
  setAppAndSiteChannelProps: (values: string[]) => void;
  setAppSiteConfigurationProps: (publishers: AppSitePublishersConfiguration) => void;
  setAudience: (audienceGroups: AudienceGroup[]) => void;
  setDeals: (deals: string[]) => void;
  setDeviceTargetingProps: (prop: any, value: any) => void;
  setIabCatVersion: (prop: string, value: number) => void;
  setMediaQualityProps: (prop: any, value: any, enabled?: boolean) => void;
  setProp: (prop: any, value: any) => void;
  setRetargetingSegment: (segment: RetargetingSegmentType | null, audienceGroups?: AudienceGroup[]) => void;
  setTemperatureAndWeatherProps: (prop: any, value: any) => void;
  setUnknownIncluded: (prop: string, value: boolean) => void;
  showDeals?: boolean;
  targeting: TargetingBaseType;
  user: UserInterface;
  userRoles: UserRoleInterface[];
}

export const TargetingContext = createContext<TargetingContextProps>({} as TargetingContextProps);

export const useTargetingContext = (): TargetingContextProps => {
  const context = useContext(TargetingContext);
  if (!context) {
    throw new Error('TargetingContext cannot be use it outside the TargetingProvider component');
  }
  return context;
};
